import React, { useRef } from 'react';
import './style.scss';
import SVGTwitter from '../../../assets/images/icons/twitter';
import SVGDiscord from '../../../assets/images/icons/discord';
import clsx from 'clsx';
import SVGShare from '../../../assets/images/icons/share';
import useAlert from '../../../contexts/alert';

interface Props {
  inverted?: boolean;
  className?: string;
  iconSize?: number;
}

const SocialButtons = ({ inverted, className, iconSize = 24 }: Props) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  const alert = useAlert();
  const domain = `https://${window.location.host}`;

  const handleCopy = () => {
    // @ts-ignore
    try {
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard
          .writeText(domain)
          .then(() => alert.show('Url copied'));
      } else {
        const el = ref.current;
        if (el) {
          el.select();
          console.log(el.value);
          // noinspection JSDeprecatedSymbols
          document.execCommand('copy');
          alert.show('Url copied');
        }
      }
    } catch (err) {
      alert.showError("Can't copy the url");
    }
  };

  return (
    <div className={clsx('social-buttons', className)}>
      <textarea className='copy-input' value={domain} readOnly ref={ref} />
      <button className='sb-button' onClick={handleCopy}>
        <SVGShare size={iconSize} color={inverted ? '#000' : '#FFF'} />
      </button>
      <a
        href='https://nifty-hands.com/twitter'
        className='sb-button'
        target='_blank'
      >
        <SVGTwitter height={iconSize} color={inverted ? '#000' : '#FFF'} />
      </a>
      <a
        href='https://nifty-hands.com/discord'
        className='sb-button'
        target='_blank'
      >
        <SVGDiscord height={iconSize} color={inverted ? '#000' : '#FFF'} />
      </a>
      {/*<a
        href='https://nifty-hands.com/instagram'
        className='sb-button'
        target='_blank'
      >
        <SVGInstagram
          height={iconSize * 1.05}
          color={inverted ? '#000' : '#FFF'}
        />
      </a>*/}
    </div>
  );
};

export default SocialButtons;
